import $ from 'zepto';

import { navigationSelector } from '../utils/constants/classes';
import { initCountryPicker } from './legacy/countryPicker';

const ANIMATE_DURATION = 400;

export const onShow = (thisPopup, popupId) => {
  setTimeout(() => {
    $($(`#${popupId}`).find('.navigation-popover__text')[0]).focus();
  }, 10);
};

function initPopover(productCountries) {
  Object.keys(productCountries).forEach((key) => {
    initCountryPicker().initializeWidget(
      productCountries[key].trigger,
      productCountries[key].currentCountry,
      productCountries[key].countries,
      1,
      '{0}',
      {
        closeBox: false,
        className: 'navigation-popover-container',
        navigationProduct: productCountries[key].navigationProduct,
        onShow,
      },
    );
  });
}

export function initNavigation(productCountries, { animate = false }) {
  const $navigation = $(navigationSelector);
  if (animate && $navigation.length > 0) {
    const leftOffset = $navigation[0].scrollWidth - $navigation.width();
    $navigation
      .children()
      .css({
        transform: `translateX(-${leftOffset}px)`,
      }).animate({
        transform: 'translateX(0)',
      }, ANIMATE_DURATION, 'ease-out');
  }

  initPopover(productCountries);
}

export default {
  onShow,
  initNavigation,
};
